import React, { useMemo } from "react";

import { Stack } from "react-bootstrap";

import { Authenticator, useAuthenticator } from "@aws-amplify/ui-react";
import { confirmResetPassword } from "aws-amplify/auth";
import { I18n } from "aws-amplify/utils";
import { useNavigate } from "react-router-dom";
import { useTypedParams } from "react-router-typesafe-routes/dom";
import { ROUTES } from "src/routes";

import { BackToSignInButton } from "@pages/SignIn/BackToSignInButton";
import { ResendCodeButton } from "@pages/SignIn/ResendCodeButton";

import { RegisterPageOutline } from "../RegisterPageOutline";

import styles from "./ResetPassword.module.scss";

// Override the default text
I18n.putVocabulariesForLanguage("en", {
  "Send code": "Confirm Email",
});

export const ResetPasswordAuthenticator = () => {
  const { user } = useTypedParams(ROUTES.ResetPassword);
  const { route } = useAuthenticator();
  const navigate = useNavigate();

  const RenderBackButton = useMemo(() => {
    return function Footer() {
      if (route === "confirmResetPassword") {
        return <ResendCodeButton username={user || ""} />;
      }
      return route === "forgotPassword" ? <BackToSignInButton /> : <></>;
    };
  }, [route, user]);

  return (
    <div className={window.navigator.userAgent.includes("Windows") ? "amplify" : ""}>
      <Authenticator
        initialState="forgotPassword"
        formFields={{
          forgotPassword: {
            username: {
              defaultValue: user || "",
            },
          },
          confirmResetPassword: {
            confirmation_code: {
              placeholder: "",
              label: "Confirmation Code",
              maxLength: 6,
            },
          },
        }}
        services={{
          async handleForgotPassword() {
            return {
              username: user || "",
              isPasswordReset: false,
              nextStep: {
                resetPasswordStep: "CONFIRM_RESET_PASSWORD_WITH_CODE",
                codeDeliveryDetails: {
                  destination: user || "",
                  deliveryMedium: "EMAIL",
                  attributeName: "email",
                },
              },
            };
          },
          async handleForgotPasswordSubmit(formData) {
            console.log("handler");
            try {
              // call the default handleForgotPasswordSubmit
              await confirmResetPassword(formData);

              // after successful password reset, navigate to your desired route
              navigate("/signin");
            } catch (error) {
              console.error("Error during password reset:", error);
              throw error;
            }
          },
        }}
        components={{
          Footer: RenderBackButton,
        }}
      ></Authenticator>
    </div>
  );
};

export const ResetPassword = () => {
  const { route } = useAuthenticator((context) => [context.route]);

  const displayNavigator = route !== "forgotPassword" && route !== "confirmResetPassword";
  return (
    <Stack className={styles["reset-password-container"]} direction="horizontal">
      <RegisterPageOutline showLogIn={false} displayNavigator={displayNavigator}>
        <ResetPasswordAuthenticator />
      </RegisterPageOutline>
    </Stack>
  );
};
